export function simpleAction(type, payload) {
    return {
        type,
        payload,
    };

}